import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { WeekDays } from "./WeekDays";
import { ProgramPath } from "./ProgramPath";
import { WellbeingSpark } from "./WellbeingSpark";
import { ChevronIcon } from "./icons";
import "./gamification.css";

/**
 * The blocks the program sidebar shows as wide facts: this week, the path,
 * the well-being curve — and, on a phone where the sidebar stacks above the
 * exercises, the last two folded behind one line so the exercises stay
 * within reach.
 */

export function WeekFact({ week }) {
  const { t } = useTranslation();
  return (
    <div className="gm gm-fact">
      <div className="gm-fact-top">
        <span>{t("gamification.week.units")}</span>
        <b>{t("gamification.week.of", { done: week.done, goal: week.goal })}</b>
      </div>
      <WeekDays days={week.days} size="sm" />
    </div>
  );
}

export function WellbeingBlock({ trend }) {
  const { t } = useTranslation();
  return (
    <div className="gm gm-fact">
      {trend.latest && (
        <div className="gm-fact-top">
          <span>{t("gamification.wellbeing.hint")}</span>
          <b>
            {trend.latest.value}
            <small>/ 10</small>
          </b>
        </div>
      )}
      <WellbeingSpark points={trend.points} />
    </div>
  );
}

export function SidebarExtras({ milestones, trend, collapsible = false }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(!collapsible);

  return (
    <div className="gm gm-fact" style={{ gap: 14 }}>
      {collapsible && (
        <button type="button" className="gm-more" onClick={() => setOpen((value) => !value)} aria-expanded={open}>
          {t(open ? "gamification.less" : "gamification.more")}
          <ChevronIcon open={open} />
        </button>
      )}
      {open && (
        <>
          <ProgramPath milestones={milestones} />
          <div>
            <p className="gm-section-label" style={{ marginBottom: 8 }}>
              {t("gamification.wellbeing.title")}
            </p>
            <WellbeingBlock trend={trend} />
          </div>
        </>
      )}
    </div>
  );
}
